var AskOurExpertsService = /** @class */ (function () {
    /*@ngInject*/
    function AskOurExpertsService($http, $timeout) {
        this.$http = $http;
        this.$timeout = $timeout;
        this.pageSize = 10;
    }
    /*@ngInject*/
    AskOurExpertsService.prototype.getDoctorQuestion = function (pageNuber) {
        var request = this.$http({
            method: "get",
            url: "/api/doctor-question?pageNumber=" + pageNuber + "&pageSize=" + this.pageSize
        });
        return (request.then(function (response) {
            return response.data.response;
        }, this.handleError));
    };
    AskOurExpertsService.prototype.postDoctorQuestion = function (data) {
        var postData = data;
        var request = this.$http.post("/api/doctor-question", postData);
        return (request.then(function (response) {
            return response.data.response;
        }, this.handleError));
    };
    return AskOurExpertsService;
}());
export default AskOurExpertsService;
//# sourceMappingURL=ask-our-experts.service.js.map